import { render, staticRenderFns } from "./SubscriptionListScreen.vue?vue&type=template&id=ddac7b6a&"
import script from "./SubscriptionListScreen.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionListScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports